import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  IconDefinition,
  IconPathData,
} from '@fortawesome/fontawesome-common-types';
import { library } from '@fortawesome/fontawesome-svg-core';
import { SvgIcon } from './create-icon-definition';

// need to create a new interface because prefix and iconName
// are restricted in IconDefinition interface
export interface CustomIconDefinition {
  prefix: string;
  iconName: string;
  icon: [
    number, // width
    number, // height
    string[], // ligatures
    '', // unicode can be an empty string without side effects
    IconPathData, // svgPathData
  ];
}

const registered = new Set<IconDefinition>();

// wrapping the library.add call in a function
// allows to detect when an icon is unused and prevent dead code
export function customIcon(icon: CustomIconDefinition) {
  // need to cast this because the prefix and iconName are
  // restricted in the IconDefinition interface
  const definition = icon as IconDefinition;
  if (!registered.has(definition)) {
    registered.add(definition);
    library.add(definition);
  }
  return definition;
}

// Using material icon registration instead of font awesome so it can play nice
// with mat-button
export function registerCustomMaterialIcons(
  iconRegistry: MatIconRegistry,
  sanitizer: DomSanitizer,
  icons: SvgIcon[],
) {
  icons.forEach((icon) =>
    iconRegistry.addSvgIconLiteral(
      icon.name,
      sanitizer.bypassSecurityTrustHtml(icon.svg),
    ),
  );
}
